import React from "react";
import FormComponent from "../components/generic/FormComponent";

const InstructionsPage: React.FC = () => {
    return (
        <FormComponent>
            <div>
                <div>
                    <h2 className="text-3xl font-extrabold mb-6 text-center sm:text-left">
                        Getting Started
                    </h2>
                    <p className="text-lg mb-10 text-center sm:text-left">
                        Learn how to effectively manage your materials and inventory with these steps.
                    </p>

                    <div className="space-y-8">
                        <div>
                            <h3 className="text-2xl font-bold mb-2">1. Navigate to the Materials Menu</h3>
                            <p>
                                Begin by accessing the <strong>Materials</strong> menu item from the main navigation.
                                This is where you can manage material types, sizes, and individual materials.
                            </p>
                        </div>
                        <div>
                            <h3 className="text-2xl font-bold mb-2">2. Add Material Types and Sizes</h3>
                            <p>
                                Create material types to define categories
                                like <strong>Biothane</strong> or <strong>Nylon</strong>.
                                Once the types are set, add sizes for these materials. For example, common sizes could
                                include
                                <strong> 3/8"</strong>, <strong>1/2"</strong>, <strong>5/8"</strong>, <strong>3/4"</strong>,
                                and <strong>1"</strong>.
                            </p>
                        </div>
                        <div>
                            <h3 className="text-2xl font-bold mb-2">3. Add Materials</h3>
                            <p>
                                After defining types and sizes, create materials by specifying:
                            </p>
                            <ul className="instruction">
                                <li>Material Type</li>
                                <li>Material Size</li>
                                <li>Color and Color Code</li>
                                <li>Initial Quantity and Unit Price (optional)</li>
                            </ul>
                            <p className="mt-2">
                                Use the <strong>Bulk Create</strong> feature to speed up the process with CSV, XLSX, or
                                text inputs.
                            </p>
                        </div>
                        <div>
                            <h3 className="text-2xl font-bold mb-2">4. Update Inventory</h3>
                            <p>
                                Navigate to the <strong>Inventory</strong> tab to view and manage inventory. Update
                                stock based on usage
                                with single updates or bulk updates using CSV, XLSX, or text.
                            </p>
                            <p>
                                Monitor inventory levels, track changes, and maintain an up-to-date balance for each
                                material.
                            </p>
                        </div>
                        <div>
                            <h3 className="text-2xl font-bold mb-2">5. Use the Inventory Table</h3>
                            <p>
                                The <strong>Inventory Table</strong> allows you to monitor all inventory items in one
                                place. Use the filtering
                                options to track specific inventory by material type, size, or color. You can also view
                                the total balance of the
                                current inventory and check the balance for each individual material.
                            </p>
                        </div>
                        <div>
                            <h3 className="text-2xl font-bold mb-2">6. Create Templates for Easy Management</h3>
                            <p>
                                For repetitive tasks, create templates to simplify inventory updates. For instance, a
                                leash template might include:
                            </p>
                            <ul className="instruction">
                                <li><strong>6ft 3/4" Biothane</strong></li>
                                <li>1 D Ring</li>
                                <li>1 Hook</li>
                                <li>6 Rivets</li>
                            </ul>
                            <p className="mt-2">
                                Save the template for future use. When building a new item, select the template and
                                update the inventory accordingly.
                            </p>
                        </div>
                        <div>
                            <h3 className="text-2xl font-bold mb-2">7. Track Change Logs</h3>
                            <p>
                                Use the <strong>History</strong> table to monitor inventory changes and ensure accurate
                                tracking over time.
                                This log provides a detailed record of all updates made to your inventory.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </FormComponent>
    );
};

export default InstructionsPage;
